//Mobile Nav
const button = document.getElementById('js-mobile');
const body = document.getElementsByTagName('body')[0];

button.addEventListener('click', (e) => {
      if (body.classList.contains('active')) {
            body.classList.remove('active')
      }
      else { body.classList.add('active') }
});


//Mobile Submenus 2
function mobileBtns() {
      const mobileBtn = document.querySelectorAll(".js-mobile");
      const body = document.getElementsByTagName('body')[0];
      const mobilebtnText = document.getElementById('js-mobile-btn-text');
      var i;

      for (i = 0; i < mobileBtn.length; i++) {
            mobileBtn[i].addEventListener("click", function (ev) {
                  if (body.classList.contains('active')) {
                        body.classList.remove('active');
                        mobilebtnText.innerHTML = "Menu";
                  }
                  else {
                        body.classList.add('active');
                        mobilebtnText.innerHTML = "Close";
                  }
            });
      }
}
mobileBtns();

//Mobile Submenus
function mobileMenu() {
      var mobileSub = document.querySelectorAll(".menu-item-has-children .circle-plus");
      var i;

      for (i = 0; i < mobileSub.length; i++) {
            mobileSub[i].addEventListener("click", function (ev) {
                  console.log('Clicked');
                  ev.preventDefault();
                  this.classList.toggle("opened");
                  var panel = this.nextElementSibling;
                  if (panel.style.maxHeight) {
                        panel.style.maxHeight = null;
                  } else {
                        panel.style.maxHeight = panel.scrollHeight + "px";
                  }
            });
      }
}

mobileMenu();

window.onload = function () {
      var w = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
      var targetWidth = 1280;
      if (w < targetWidth) {
            mobileMenu();
      }
}

// Sticky Appointment
function aptDeskTopForm() {
      var aptBtn = document.getElementById("aptBtn");
   
      var w = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
      var targetWidth = 1024;
      if (w > targetWidth) {
            aptBtn.classList.toggle("active");
            var panel = aptBtn.nextElementSibling;
            if (panel.style.maxHeight) {
                  panel.style.maxHeight = null;
            } else {
                  panel.style.maxHeight = panel.scrollHeight + "px";
            }
      }
      
      aptBtn.addEventListener("click", function (ev) {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                  panel.style.maxHeight = null;
            } else {
                  panel.style.maxHeight = panel.scrollHeight + "px";
            }
      });

}

window.onload = aptDeskTopForm(); 


/* Video Blog Section */
jQuery('.video-blogs .uagb-section__inner-wrap').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      centerMode: true,
      variableWidth: true,
      autoplay: false,
      autoplaySpeed: 4000,
      infinite: true,
      focusOnSelect: true,
      cssEase: 'linear',
      touchMove: true,
      prevArrow: '<button class="slick-prev"> < </button>',
      nextArrow: '<button class="slick-next"> > </button>',
      responsive: [                        
                  {
               breakpoint: 765,
                  settings: {
                        slidesToShow: 1,
                      centerMode: false,
                      variableWidth: false,
                    }
                  },
              ]
});

/* Home Content Slider Below Hero */
jQuery('.home-content-slider .uagb-section__inner-wrap').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 6000,
      infinite: true,
      focusOnSelect: true,
      cssEase: 'linear',
      touchMove: true,
      prevArrow: '<button class="slick-prev"><svg width="56" height="56" viewBox="0 0 56 56"><g id="Play_Circle" data- name="Play Circle" transform = "translate(56 56) rotate(180)" ><circle id="Ellipse_2" data-name="Ellipse 2" cx="28" cy="28" r="28" fill="rgba(103,201,224,0.25)"/><path id="Path_5" data-name="Path 5" d="M18.789,11.563,0,0V23.125Z" transform="translate(21.105 16.437)" fill="#fff"/></g></svg ></button>',
      nextArrow: '<button class="slick-next"><svg id="Play_Circle" data-name="Play Circle" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"> <circle id="Ellipse_2" data-name="Ellipse 2" cx="28" cy="28" r="28" fill="rgba(103,201,224,0.25)"/> <path id="Path_5" data-name="Path 5" d="M18.789,11.563,0,0V23.125Z" transform="translate(21.105 16.437)" fill="#fff"/> </svg></button>',
});

/* Testimonials */
jQuery('.home-testimonials .uagb-section__inner-wrap').slick({
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
});

//Search Blog Button Slide Out
const searchBtn = document.getElementById('search-btn');
const searchContain = document.getElementById('search-contain');

if (searchBtn) {
      searchBtn.addEventListener('click', (e) => {
            if (searchContain.classList.contains('active')) {
                  searchContain.classList.remove('active')
            }
            else { searchContain.classList.add('active') }
      });
};

// Option Select Menu
function showPage() {
      var sel = document.getElementById('categories');

      var option = sel.options[sel.selectedIndex].value;

      window.open(option + ".html");
}

// Accordian
(function () {
      const headings = document.querySelectorAll(".accordion__heading");
      const triggers = [];
      const accordionContents = document.querySelectorAll(".accordion__copy");
      const multiselect = document.getElementById("multiselect");
      const copyOpenClass = "accordion__copy--open";

      headings.forEach((h, i) => {
            let btn = h.querySelector("button");
            triggers.push(btn);
            let target = h.nextElementSibling;
            btn.onclick = () => {
                  let expanded = btn.getAttribute("aria-expanded") === "true";
                  if (expanded) {
                        closeItem(target, btn);
                  } else {
                        openItem(target, btn);
                  }
            };
      });
      function closeAllExpandedItems() {
            const expandedTriggers = triggers.filter(
                  (t) => t.getAttribute("aria-expanded") === "true"
            );
            const expandedCopy = Array.from(accordionContents).filter((c) =>
                  c.classList.value.includes(copyOpenClass)
            );
            expandedTriggers.forEach((trigger) => {
                  trigger.setAttribute("aria-expanded", false);
            });
            expandedCopy.forEach((copy) => {
                  copy.classList.remove(copyOpenClass);
                  copy.style.maxHeight = 0;
                  copy.style.padding = "0 1.5rem 0 1.5rem";
            });
      }
      function closeItem(target, btn) {
            if (!multiselect.checked) {
                  closeAllExpandedItems();
            } else {
                  btn.setAttribute("aria-expanded", false);
                  target.classList.remove(copyOpenClass);
                  target.style.maxHeight = 0;
                  target.style.padding = "0 1.5rem 0 1.5rem";
            }
      }
      function openItem(target, btn) {
            if (!multiselect.checked) {
                  closeAllExpandedItems();
            }
            btn.setAttribute("aria-expanded", true);
            target.classList.add(copyOpenClass);
            target.style.maxHeight = target.scrollHeight + "px";
            target.style.padding = "1rem 1.5rem 2rem 1.5rem";
      }
      
})();
